/* unplugin-vue-components disabled */import { render } from "./VabSubMenu.vue?vue&type=template&id=03acfcb1&ts=true"
import script from "./VabSubMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./VabSubMenu.vue?vue&type=script&lang=ts&setup=true"
/* custom blocks */
import block0 from "./VabSubMenu.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"library/components/VabMenu/components/VabSubMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03acfcb1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03acfcb1', __exports__)) {
    api.reload('03acfcb1', __exports__)
  }
  
  module.hot.accept("./VabSubMenu.vue?vue&type=template&id=03acfcb1&ts=true", () => {
    api.rerender('03acfcb1', render)
  })

}


export default __exports__